import React, { useState } from "react";
import "./AddCategory.css";
import { useFormik } from "formik";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate } from "react-router";
import { addcategorylist } from "../../service/Mainservice";
import addimg from "../../assets/image.png";

const validate = (values) => {
  const errors = {};
  if (!values.name) errors.name = "Category name is required";
  if (!values.preview) errors.preview = "Please upload an image";
  return errors;
};

const AddCategory = () => {
  const [load, setload] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [image, setImage] = useState(null);

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { name: "", preview: "" },
    validate,
    onSubmit: (values) => handleAdd(values),
  });

  const handleAdd = async (values) => {
    setload(true);
    try {
      await addcategorylist(image, values.name);
      navigate("/Categories_List");
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setload(false);
    }
  };

  const handleupload = (e) => {
    if (e.target && e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setImage(file);
      formik.setFieldValue("preview", URL.createObjectURL(file));
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Add Category</h1>
        </div>

        <div className="category-card">
          <form onSubmit={formik.handleSubmit} className="category-form">
            {/* Name Field */}
            <div className="category-field-group">
              <label className="category-field-label">
                <span>Category Name</span>
                <span className="required-star">*</span>
              </label>
              <input
                type="text"
                name="name"
                placeholder="e.g. Electronics, Grocery, etc."
                onChange={formik.handleChange}
                value={formik.values.name}
                className={`category-input ${formik.errors.name && "category-input-error"}`}
              />
              {formik.errors.name && (
                <p className="category-error">{formik.errors.name}</p>
              )}
            </div>

            {/* Image Upload */}
            <div className="category-field-group">
              <label className="category-field-label">
                <span>Category Image</span>
                <span className="required-star">*</span>
              </label>
              <div className="category-upload-area">
                <input
                  type="file"
                  id="category-image-upload"
                  accept="image/*"
                  onChange={handleupload}
                  style={{ display: "none" }}
                />
                <label
                  htmlFor="category-image-upload"
                  className="category-upload-label"
                >
                  {formik.values.preview ? (
                    <div className="category-preview-wrapper">
                      <img
                        src={formik.values.preview}
                        alt="Category preview"
                        className="category-preview-image"
                      />
                      <div className="category-preview-overlay">
                        <span>Change image</span>
                      </div>
                    </div>
                  ) : (
                    <div className="category-upload-placeholder">
                      <img
                        src={addimg}
                        alt="Upload"
                        className="category-upload-icon"
                      />
                      <p>Click to upload an image</p>
                      <span>PNG, JPG up to 5MB</span>
                    </div>
                  )}
                </label>
              </div>
              {formik.errors.preview && (
                <p className="category-error">{formik.errors.preview}</p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="category-submit-btn"
              disabled={load}
            >
              {load ? (
                <span className="category-loader">Saving...</span>
              ) : (
                "Create Category"
              )}
            </button>
          </form>
        </div>
      </div>

      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddCategory;
